import {
  createRouter,
  createWebHistory
} from "vue-router";

const routerHistory = createWebHistory();
const routes = [{
    path: "",
    redirect: "/layout",
  },
  {
    path: "/layout",
    name: "layout",
    component: () => import("@/views/layout.vue"),
    redirect: "/index",
    children: [{
        // 首页
        path: "/index",
        name: "index",
        component: () => import("@/views/index.vue"),
      },
      {
        // 产品中心
        path: "/goodsIndex",
        name: "goods",
        // component: () => import("@/views/goods/goodsDSP.vue"),
        children: [{
            path: "/goodsIndex",
            name: "goodsIndex",
            component: () => import("@/views/goods/goodsIndex.vue"),
          },
          {
            path: "/goodsDSP",
            name: "goodsDSP",
            component: () => import("@/views/goods/goodsDSP.vue"),
          },
          {
            path: "/goodsDSE",
            name: "goodsDSE",
            component: () => import("@/views/goods/goodsDSE.vue"),
          },
          {
            path: "/goodsDVP",
            name: "goodsDVP",
            component: () => import("@/views/goods/goodsDVP.vue"),
          },
          {
            path: "/goodsIBP",
            name: "goodsIBP",
            component: () => import("@/views/goods/goodsIBP.vue"),
          },
          {
            path: "/goodsOCP",
            name: "goodsOCP",
            component: () => import("@/views/goods/goodsOCP.vue"),
          },
          {
            path: "/goodsDGP",
            name: "goodsDGP",
            component: () => import("@/views/goods/goodsDGP.vue"),
          },
          {
            path: "/goodsUOM",
            name: "goodsUOM",
            component: () => import("@/views/goods/goodsUOM.vue"),
          },
          {
            path: "/goodsUSP",
            name: "goodsUSP",
            component: () => import("@/views/goods/goodsUSP.vue"),
          },
          {
            path: "/goodsUID",
            name: "goodsUID",
            component: () => import("@/views/goods/goodsUID.vue"),
          },
          {
            path: "/goodsDTP",
            name: "goodsDTP",
            component: () => import("@/views/goods/goodsDTP.vue"),
          },
          {
            path: "/goodsRDE",
            name: "goodsRDE",
            component: () => import("@/views/goods/goodsRDE.vue"),
          },
          {
            path: "/goodsCOP",
            name: "goodsCOP",
            component: () => import("@/views/goods/goodsCOP.vue"),
          },
        ],
      },
      {
        // 解决方案
        path: "/solution",
        name: "solut",
        children: [{
            path: "/finance",
            name: "solution/finance",
            component: () => import("@/views/solution/finance.vue"),
          },
          {
            path: "/retailing",
            name: "solution/retailing",
            component: () => import("@/views/solution/retailing.vue"),
          },
          {
            path: "/operator",
            name: "solution/operator",
            component: () => import("@/views/solution/operator.vue"),
          },
          {
            path: "/publicServe",
            name: "solution/publicServe",
            component: () => import("@/views/solution/publicServe.vue"),
          },
           {
            path: "/panInternet",
            name: "solution/panInternet",
            component: () => import("@/views/solution/panInternet.vue"),
          }
        ],
      },
      {
        // 客户案例
        path: "/caseIndex",
        name: "case",
        children: [{
            path: "/caseIndex",
            name: "caseIndex",
            component: () => import("@/views/customerCase/caseIndex.vue"),
          },
          {
            path: "/caseDetail",
            name: "caseDetail",
            component: () => import("@/views/customerCase/caseDetail.vue"),
          },
        ],
      },
      {
        // 关于我们
        path: "/aboutUs",
        name: "about",
        // component: () => import("@/views/aboutUs.vue"),
        children: [{
            path: "companyDynamic",
            name: "aboutUs/companyDynamic",
            component: () => import("@/views/aboutUs/companyDynamic.vue"),
          },
          {
            path: "dynamicDetail",
            name: "aboutUs/dynamicDetail",
            component: () => import("@/views/aboutUs/dynamicDetail.vue"),
          },
          {
            path: "introduction",
            name: "aboutUs/introduction",
            component: () => import("@/views/aboutUs/introduction.vue"),
          },
          {
            path: "joinUs",
            name: "aboutUs/joinUs",
            component: () => import("@/views/aboutUs/joinUs.vue"),
          },
          {
            path: "fileDown",
            name: "aboutUs/fileDown",
            component: () => import("@/views/aboutUs/fileDown.vue"),
          }
        ],
      },
      {
        // 联系我们
        path: "/contactUs",
        name: "contactUs",
        component: () => import("@/views/aboutUs/contactUs.vue")
      },
    ],
  },
];
const router = createRouter({
  history: routerHistory,
  routes,
});

export default router;